import { ApolloClient, InMemoryCache } from '@apollo/client'
import { useAsync } from '@arcxmoney/arcx-react'
import { BigNumber, utils } from 'ethers'
import React from 'react'
import { ArcButton } from 'src/components/ArcButton'
import { AllocationService } from 'src/services/AllocationService'

export function Phase2AllocationPage() {
  const [csv] = useAsync(async () => {
    const apolloClient = new ApolloClient({
      uri: 'https://api.thegraph.com/subgraphs/name/xitronix/linkusd',
      cache: new InMemoryCache(),
    })
    const service = new AllocationService(
      apolloClient,
      Math.round(Date.UTC(2021, 0, 20) / 1000),
      Math.round(Date.UTC(2021, 2, 3) / 1000),
      utils.parseEther('120'),
    )
    const liquidityActions = await service.fetchLiquidityActions()
    const summaryData = service.getSummary(liquidityActions)
    console.log(
      'total amount of token',
      summaryData
        .reduce<BigNumber>((prev, cur) => prev.add(cur[1]), BigNumber.from('0'))
        .toString(),
    )
    console.log(
      'total part',
      summaryData
        .reduce<BigNumber>(
        (prev, cur) => prev.add(utils.parseEther(cur[2].toString())),
        BigNumber.from('0'),
      )
        .toString(),
    )

    return summaryData
      .map((row) => {
        row[1] = row[1].toString()
        return row
      })
      .reduce((csv, row) => {
        return csv + row.join(',') + '\n'
      }, 'Account,Amount,Part\n')
  }, [])

  const onDownloadClick = () => {
    const hiddenElement = document.createElement('a')
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
    hiddenElement.target = '_blank'
    hiddenElement.download = 'Phase2Allocation.csv'
    hiddenElement.click()
  }

  return (
    <div className="phase1-sale-page page">
      <ArcButton disabled={!csv} onClick={onDownloadClick} name="download Allocation summary" />
    </div>
  )
}
